import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initConsultingLens(): void {
    const lens = document.querySelector('.clarity-lens');
    if (!lens) return;

    // Follow mouse within section
    const section = document.querySelector('.cons-lens');
    if (!section) return;

    section.addEventListener('mousemove', (e: any) => {
        const rect = section.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        gsap.to(lens, {
            x: x - rect.width / 2,
            y: y - rect.height / 2,
            duration: 0.6,
            ease: 'power2.out'
        });
    });
}

export function initConsultingTimeline(): void {
    const items = document.querySelectorAll('.timeline-item');
    if (items.length === 0) return;

    gsap.from(items, {
        opacity: 0,
        x: -30,
        stagger: 0.4,
        duration: 0.8,
        ease: 'expo.out',
        scrollTrigger: {
            trigger: '.vertical-timeline',
            start: 'top 70%'
        }
    });
}
